'use client'

import { useEffect } from 'react'

import { ErrorHandler } from '@/lib/errors/error-handlers'
import UnderMaintenance from '@/components/common/under-maintenance'

interface ErrorProps {
  error?: Error & { digest?: string }
  reset?: () => void
}

/**
 * Root App Error Boundary
 * Handles errors in the app directory root
 */
export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    // Only log if we have an actual error object
    if (error) {
      ErrorHandler.handle(error, {
        source: 'app-error-boundary',
        digest: error?.digest,
        path: '/',
      })
    }
  }, [error])

  return (
    <UnderMaintenance
      variant="error"
      showRetry={!!reset}
      onRetry={reset ?? (() => {})}
      showHomeButton
      homeUrl="/"
      errorDetails={error?.message ?? ''}
      errorId={error?.digest ?? ''}
      isDashboard={false}
    />
  )
}
